/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type {
	WhatsAppTemplateIndexPathParams,
	WhatsAppTemplateIndexQueryParams,
	WhatsAppTemplateIndexResponse,
} from '../types/WhatsAppTemplateIndex'

/**
 * GET /organisations/:organisationId/whatsapp-templates
 * @see backend/nexus/modules/Campaign/Http/Controllers/WhatsAppTemplateController.php WhatsAppTemplateController::index
 */
export async function whatsAppTemplateIndex(
	organisationId: WhatsAppTemplateIndexPathParams['organisationId'],
	params?: WhatsAppTemplateIndexQueryParams,
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<WhatsAppTemplateIndexResponse>> {
	return axiosInstance.get(`/organisations/${organisationId}/whatsapp-templates`, { params, ...config })
}
